<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-card class="card--shadow">
            <admin-list :admins="admins" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import AdminList from "@/components/admin/AdminList";

export default {
  components: {
    AdminList,
  },
  computed: {
    ...mapState("Admin", ["admins"]),
  },
  methods: {
    ...mapActions("Admin", ["getAdmins"]),
  },
  created() {
    this.getAdmins();
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
